import React from "react";
import PropTypes from "prop-types";

const Ellipses = ({ svgId, transparent }) => {
  return (
    <svg
      id={svgId}
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity={transparent ? "0.2" : "1.0"}
        cx="3.60131"
        cy="3.59997"
        r="2.73082"
        fill="#005D7D"
      />
    </svg>
  );
};

export default Ellipses;

Ellipses.propTypes = {
  svgId: PropTypes.string,
  transparent: PropTypes.bool
};

Ellipses.defaultProps = {
  svgId: null,
  transparent: true
};
